import { AuthClient } from './AuthClient';

export const securityClient = new AuthClient();
